<template>
  <div class="flex flex-col">
    <select
      v-bind="$attrs"
      v-model="inputValue"
      :name="name"
    >
      <option
        disabled
        :value="undefined"
      >
        {{ $props.emptyText }} {{ $props.optional ? `(${$t('Select.optional')})` : '' }}
      </option>

      <template v-if="hasValues">
        <option
          v-for="(option, i) in ($props.options as any)"
          :key="i"
          :value="option.value"
          :title="option.title"
        >
          {{ option.label }}
        </option>
      </template>

      <template v-else>
        <option
          v-for="(option, i) in $props.options"
          :key="i"
        >
          {{ option }}
        </option>
      </template>
    </select>

    <span
      v-if="error"
      class="text-red-600 text-sm"
    >{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
import { t } from '@/i18n';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    name: string;
    // modelValue: string | number | null | undefined;
    error?: string;
    options: string[] | number[] | undefined | ({ value: string | number; label: string; title?: string })[];
    optional?: boolean;
    emptyText?: string;
  }>(),
  {
    error: undefined,
    options: () => [],
    /* eslint-disable no-null/no-null */
    // modelValue: null,
    optional: false,
    emptyText: () => t('Select.emptyText'),
  },
);

// defineEmits(['update:modelValue']);
const inputValue = defineModel();

const hasValues = computed(() => {
  return props.options.findIndex((option) => {
    return typeof option === 'object' &&
      'value' in option;
  }) !== -1;
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<style lang="css" scoped></style>
